<template>
  <div style="width: 100%; height: 100%;">
    <canvas id="alerts-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'alerts-chart',
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      chartObj: null,
      alertsChartData: {
        type: 'line',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Alertas',
              data: [],
              borderColor: '#424242',
              borderWidth: 3,
              tension: 0.3,
              fill: true,
              backgroundColor: 'rgba(66, 66, 66, 0.2)',
            },
            {
              label: 'Fichajes',
              data: [],
              borderColor: '#1976D2',
              borderWidth: 2,
              borderDash: [5, 5],
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                boxWidth: 12,
                color: '#666666',
              },
            },
            tooltip: {
              mode: 'index',
              intersect: false,
            },
          },
          scales: {
            x: {
              ticks: { color: '#666666' },
              grid: { color: 'rgba(0, 0, 0, 0.1)' },
            },
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0,
                color: '#666666',
              },
              grid: { color: 'rgba(0, 0, 0, 0.1)' },
            },
          },
        },
      },
    };
  },

  mounted() {
    this.applyThemeToChart();
    const ctx = document.getElementById('alerts-chart');
    // eslint-disable-next-line no-new
    this.chartObj = new Chart(ctx, this.alertsChartData);
  },

  watch: {
    chartData: {
      handler(newVal) {
        this.updateChartData(newVal);
      },
      deep: true,
      immediate: true,
    },
    '$vuetify.theme.dark': {
      handler() {
        if (this.chartObj) {
          this.applyThemeToChart();
          this.chartObj.update();
        }
      },
    },
  },

  methods: {
    hexToRgba(hex, alpha) {
      if (!hex || !hex.startsWith('#')) return `rgba(128, 128, 128, ${alpha})`;
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      const fullHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
      if (!result) return `rgba(128, 128, 128, ${alpha})`;
      const r = parseInt(result[1], 16);
      const g = parseInt(result[2], 16);
      const b = parseInt(result[3], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    applyThemeToChart() {
      const isDark = this.$vuetify.theme.dark;
      const themeConfig = this.$vuetify.theme.themes ? this.$vuetify.theme.themes[isDark ? 'dark' : 'light'] : {};

      let primaryColor = themeConfig.primary || '#1976D2';
      if (typeof primaryColor === 'object') primaryColor = primaryColor.base || '#1976D2';

      let secondaryColor = themeConfig.secondary || '#424242';
      if (typeof secondaryColor === 'object') secondaryColor = secondaryColor.base || '#424242';

      const textColor = isDark ? '#e0e0e0' : '#666666';
      const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

      // Colors for datasets
      this.alertsChartData.data.datasets[0].borderColor = secondaryColor;
      this.alertsChartData.data.datasets[0].backgroundColor = this.hexToRgba(secondaryColor, 0.2);
      this.alertsChartData.data.datasets[1].borderColor = primaryColor;

      // Colors for options
      this.alertsChartData.options.plugins.legend.labels.color = textColor;
      this.alertsChartData.options.scales.x.ticks.color = textColor;
      this.alertsChartData.options.scales.x.grid.color = gridColor;
      this.alertsChartData.options.scales.y.ticks.color = textColor;
      this.alertsChartData.options.scales.y.grid.color = gridColor;
    },
    updateChartData(temporalData) {
      if (!this.chartObj || !temporalData) return;

      const labels = temporalData.map((d) => {
        const parts = d.label.split(' ');
        if (parts.length >= 2) return `${parts[0]} ${parts[1]}`;
        return d.date;
      });
      const alertCounts = temporalData.map((d) => d.alertsCount);
      const entriesCounts = temporalData.map((d) => d.entriesCount);

      this.alertsChartData.data.labels = labels;
      this.alertsChartData.data.datasets[0].data = alertCounts;
      this.alertsChartData.data.datasets[1].data = entriesCounts;

      this.chartObj.update();
    },
  },
};
</script>
